import './person-hero.scss';
import './person-hero.html.twig';

import objectFitImages from 'object-fit-images';

export default function () {
  const hero = document.querySelector('.hero');
  if (!hero) {
    return;
  }
  const heroImage = hero.querySelector('picture img');
  objectFitImages(heroImage);
}
